import {
	type LastUpdatedFilter,
	type ProductTypeFilter,
	type SubTypeFilter,
} from '../../ui/enterprise-feedback-comparison/types';

export enum FeedbackRating {
	ONE = '1',
	TWO = '2',
	THREE = '3',
	FOUR = '4',
	FIVE = '5',
}

export enum FeedbackProduct {
	CONFLUENCE = 'confluence',
	JIRA = 'jira',
	ATLAS = 'atlas',
	SHAREPOINT = 'sharepoint',
	GOOGLE = 'google',
	OTHER = 'other',
}
export const getEnumValueFromForm = (formValue: string): FeedbackRating | undefined => {
	const values = Object.values(FeedbackRating);
	const found = values.find((value) => value === formValue);
	return found as FeedbackRating | undefined;
};

// transforms type filter from query params to the format expected by Manifold
export const transformTypeFilter = (type: string): SubTypeFilter => {
	switch (type) {
		case 'page':
		case 'space':
		case 'attachment':
		case 'whiteboard':
			return `${type}s`;
		case 'blogpost':
			return 'blog-posts';
		case 'project':
			return 'product'; // this is the value in BE
		default:
			return type as SubTypeFilter;
	}
};

// transforms lastUpdated filter from query params to the format expected by Manifold
export const transformLastUpdatedFilter = (lastUpdated: string): LastUpdatedFilter => {
	switch (lastUpdated) {
		case 'past7Days':
			return 'past-7-days';
		case 'past30Days':
			return 'past-30-days';
		case 'pastYear':
			return 'past-year';
		default:
			return lastUpdated as LastUpdatedFilter; // today, yesterday, anytime
	}
};

type GetFiltersReturnType = {
	assigneeFilter?: string[];
	contentUnderFilter?: string;
	contributorFilter?: string[];
	lastUpdatedFilter?: LastUpdatedFilter;
	productTypeFilter?: ProductTypeFilter;
	projectIdFilter?: string;
	spaceFilter?: string[];
	titleMatchFilter?: boolean;
	typeFilter?: SubTypeFilter;
};

// transforms query params to a filter object in the format expected by Manifold
export const getFilters = (queryParams: Record<string, any>): GetFiltersReturnType | undefined => {
	const {
		product,
		type,
		jAssignee,
		jProject,
		lastModified,
		contributors,
		spaces,
		ancestor,
		titleMatch,
	} = queryParams;

	const filters = {
		...(product ? { productTypeFilter: product === 'townsquare' ? 'atlas' : product } : {}),
		...(type ? { typeFilter: transformTypeFilter(type) } : {}),
		...(jAssignee ? { assigneeFilter: jAssignee.split(',') } : {}),
		...(jProject ? { projectIdFilter: jProject } : {}),
		...(lastModified ? { lastUpdatedFilter: transformLastUpdatedFilter(lastModified) } : {}),
		...(contributors ? { contributorFilter: contributors.split(',') } : {}),
		...(spaces ? { spaceFilter: spaces.split(',') } : {}),
		...(ancestor ? { contentUnderFilter: ancestor } : {}),
		...(titleMatch ? { titleMatchFilter: titleMatch === 'true' } : {}),
	};

	return Object.keys(filters).length ? filters : undefined;
};

export const formatPresetAndFreeformFeedback = (
	ratingReasons: string[] | undefined,
	feedback: string | undefined,
): string | undefined => {
	const formattedReasons = `preset: ${ratingReasons ? ratingReasons.join(', ') : ''}`;
	const formattedFeedback = feedback ? `feedback: ${feedback}` : 'feedback: ';
	if ((!ratingReasons || !ratingReasons.length) && !feedback) {
		return undefined;
	}
	return `${formattedReasons}; ${formattedFeedback}`;
};
